(function(root,factory){
  if(typeof module==='object'&&module.exports)module.exports=factory();
  else root.PocketGallery=factory();
})(typeof window!=='undefined'?window:this,function(){
  'use strict';
  function init(scope){
    const gallery=scope.querySelector('[data-gallery]');
    if(!gallery||gallery.dataset.galleryReady)return null;
    const scene=gallery.querySelector('[data-gallery-main]');
    const buttons=[...gallery.querySelectorAll('[data-gallery-view]')];
    const strip=gallery.querySelector('.pf-detail-strip');
    if(!scene||!buttons.length)return null;
    gallery.dataset.galleryReady='true';
    function select(index,focus=false){
      const button=buttons[(index+buttons.length)%buttons.length];
      scene.dataset.scene=button.dataset.galleryView;
      buttons.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
      if(focus)button.focus({preventScroll:true});
      const left=button.offsetLeft,right=left+button.offsetWidth;
      if(left<strip.scrollLeft||right>strip.scrollLeft+strip.clientWidth)
        strip.scrollTo?.({left:Math.max(0,left-(strip.clientWidth-button.offsetWidth)/2),behavior:'auto'});
    }
    buttons.forEach((button,index)=>{
      button.addEventListener('click',()=>select(index));
      button.addEventListener('keydown',event=>{
        const next={ArrowRight:index+1,ArrowLeft:index-1,Home:0,End:buttons.length-1}[event.key];
        if(next===undefined)return;
        event.preventDefault();select(next,true);
      });
    });
    return {select};
  }
  return {init};
});
